import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextInput } from '@moonpig/launchpad-forms'
import { Box } from '@moonpig/launchpad-components'

import { Region } from '@moonpig/web-core-types'
import { FormStep, ValidationError } from './types'
import { useAuthenticationLocaleText } from '../../text-localisation'
import { restrictInput } from './utils'

export const RegistrationFields: React.FC<{
  validationErrors: ValidationError[]
  region: Region
}> = ({ validationErrors }) => {
  const MAX_FIELD_LENGTH = 30
  const localiseText = useAuthenticationLocaleText()
  const { control, getValues } = useFormContext()
  const { formStep } = getValues()

  const getHelperText = (key: string, errorMessage?: string) => {
    return errorMessage ?? validationErrors.find(e => e.field === key)?.message
  }

  const showRegistrationFields =
    formStep === FormStep.REGISTER || formStep === FormStep.CODE_PRE_REGISTER

  return (
    <Box display={showRegistrationFields ? '' : 'none'}>
      <Controller
        control={control}
        name="firstName"
        rules={{
          maxLength: {
            message: localiseText('auth_wizard.firstName_length_error'),
            value: MAX_FIELD_LENGTH,
          },
          required: {
            message: localiseText('auth_wizard.register.firstName_error'),
            value: showRegistrationFields,
          },
        }}
        render={({
          field: { name, value, onChange },
          fieldState: { error },
        }) => (
          <TextInput
            mb={6}
            type="text"
            name={name}
            value={value}
            onChange={restrictInput(onChange, 'firstName')}
            label={localiseText('auth_wizard.register.firstName_label')}
            error={
              !!(error || validationErrors.find(e => e.field === 'firstName'))
            }
            helperText={getHelperText('firstName', error?.message)}
            autoCorrect="off"
            spellCheck="false"
            autoComplete="given-name"
          />
        )}
      />
      <Controller
        control={control}
        name="lastName"
        rules={{
          maxLength: {
            message: localiseText('auth_wizard.lastName_length_error'),
            value: MAX_FIELD_LENGTH,
          },
          required: {
            message: localiseText('auth_wizard.register.lastName_error'),
            value: showRegistrationFields,
          },
        }}
        render={({
          field: { name, value, onChange },
          fieldState: { error },
        }) => (
          <TextInput
            mb={8}
            type="text"
            name={name}
            value={value}
            onChange={restrictInput(onChange, 'lastName')}
            label={localiseText('auth_wizard.register.lastName_label')}
            error={
              !!(error || validationErrors.find(e => e.field === 'lastName'))
            }
            helperText={getHelperText('lastName', error?.message)}
            autoCorrect="off"
            spellCheck="false"
            autoComplete="family-name"
          />
        )}
      />
    </Box>
  )
}
